// Человекочитаемые лейблы для всех enum-значений.
// Используются и в Mini App (формы), и в боте (уведомления), и в админке.
export const applicationTypeLabels = {
    ADVISORY_BOARD: "💼 Advisory Board",
    EVENT_CONSULTING: "🎤 Консалтинг по мероприятиям",
    MARKETING_CONSULTATION: "📈 Маркетинг — разовая консультация",
    MARKETING_STRATEGY: "📈 Маркетинг — стратегия",
    TIME_MANAGEMENT: "🕘 Система тайм-менеджмента «Как у Антона»",
    AUTOMATION: "🤖 Автоматизация бизнеса",
    RESIDE_INVESTMENT: "🏝 RESIDE — инвестиции",
    VILLA_RENT: "🏖 Аренда виллы",
    COCOON_INVESTMENT: "🌿 Cocoon Resort — акционерство",
    INSTAGRAM_ADS: "📣 Реклама в Instagram",
    PARTNERSHIP: "🤝 Партнёрство",
};
export const applicationStatusLabels = {
    NEW: "Новая",
    IN_PROGRESS: "В работе",
    CONTACTED: "Связались",
    WON: "Сделка",
    REJECTED: "Отказ",
};
export const villaLeadStatusLabels = {
    NEW: "Новая",
    SENT_TO_IRA: "Передана Ире",
    IN_PROGRESS: "В работе у Иры",
    DEAL: "Сделка",
    REJECTED: "Отказ",
};
export const recipientLabels = {
    ANTON: "Антон",
    ALENA: "Алёна",
    IRA: "Ира",
};
// ----- Эвент-консалтинг -----
export const eventFormatLabels = {
    LAUNCH: "🚀 Сопровождение под запуск (8–16 недель)",
    PARTNERSHIP: "🤝 Партнёрство на несколько мероприятий",
    CONSULTATION: "🗺 Разовая консультация (дорожная карта)",
};
// ----- Тайм-менеджмент -----
export const timeMgmtFormatLabels = {
    IN_PERSON: "Лично",
    ZOOM: "Zoom",
};
// ----- RESIDE -----
export const residePropertyTypeLabels = {
    APARTMENTS: "Апартаменты",
    VILLA: "Вилла",
    TOWNHOUSE: "Таунхаус",
    UNDECIDED: "Не определился",
};
export const resideStrategyLabels = {
    LOW_RISK: "Низкорисковая",
    MODERATE: "Умеренная",
    HIGH_RISK: "Высокий риск, высокая доходность",
    UNDECIDED: "Не определился",
};
export const residePurposeLabels = {
    INVESTMENT_ONLY: "Только инвестиции",
    LIVING: "Для жизни",
    MIXED: "Инвестиции + иногда жить",
};
export const resideReadinessLabels = {
    READY: "Готовая (быстрый доход)",
    UNDER_CONSTRUCTION: "Строящаяся (рост цены)",
    ANY: "Не принципиально",
};
export const resideBudgetLabels = {
    UP_100K: "до $100 000",
    UP_150K: "до $150 000",
    UP_200K: "до $200 000",
    UP_500K: "до $500 000",
    OVER_500K: "свыше $500 000",
};
export const resideTimelineLabels = {
    MONTHS: "В течение пары месяцев",
    YEAR: "В течение года",
    STUDYING: "Пока изучаю",
};
export const resideChannelLabels = {
    WHATSAPP: "WhatsApp",
    TELEGRAM: "Telegram",
    VIBER: "Viber",
};
// ----- Аренда виллы -----
export const villaLocationLabels = {
    SEMINYAK: "🏖 Семиньяк",
    ULUWATU: "🌊 Улувату",
    CANGGU: "🌾 Чангу",
    UBUD: "🌿 Убуд",
    UNDECIDED: "Не определился",
};
export const villaBudgetLabels = {
    UP_2K: "до $2 000/мес",
    BTW_2_5K: "$2 000 – $5 000/мес",
    BTW_5_10K: "$5 000 – $10 000/мес",
    OVER_10K: "свыше $10 000/мес",
};
// ----- Cocoon -----
export const cocoonPackageLabels = {
    STARTER: "🌱 Старт — $40 000 (1%)",
    PARTNER: "🤝 Партнёр — $190 000 (5%)",
    CO_INVESTOR: "💎 Со-инвестор — $350 000 (10%)",
    CUSTOM: "💼 Свой вариант (>10%)",
    EXPLORING: "🤔 Пока изучаю",
};
export const cocoonTimelineLabels = {
    NOW: "Прямо сейчас",
    MONTHS: "1–3 месяца",
    STUDYING: "Изучаю, нужно больше информации",
};
export const cocoonExperienceLabels = {
    FIRST_TIME: "Первая инвестиция",
    FEW_PROJECTS: "1–3 проекта в портфеле",
    EXPERIENCED: "Опытный инвестор",
};
// ----- Реклама -----
export const adsTypeLabels = {
    ONE_TIME: "Разовая реклама",
    CONTRACT: "Контракт",
};
//# sourceMappingURL=labels.js.map